/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const GridConnectionLevel = {
    NotSpecified: 'NotSpecified',
    AHigh: 'AHigh',
    ALow: 'ALow',
    BHigh: 'BHigh',
    BLow: 'BLow',
    C: 'C',
    AHighPlus: 'AHighPlus',
    A0: 'A0',
} as const;
export type GridConnectionLevel = typeof GridConnectionLevel[keyof typeof GridConnectionLevel];

